import { ButtonHTMLAttributes } from "react"

const PrimaryButton = ({ className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <button {...props} className={`primary-button ${className}`} type="button" />
}

export default PrimaryButton